// Standardized Invite Flow Events
export const INVITE_STEP_COMPLETE = 'invite_step_complete';

// Standardized Invite Flow Errors
export const INVITE_LINK_ERROR = 'invite_link_error';

// Standardized Invite Flow Steps
export const INVITE_SENT = 'invite_sent';
